var coolCountDownTimer = {
  getDays: function(timestamp) {
    return Math.max(Math.floor(timestamp / (1000 * 60 * 60 * 24)), 0);
  },
  getHours: function(timestamp) {
    return Math.max(Math.floor((timestamp % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)), 0);
  },
  getMinutes: function(timestamp) {
    return Math.max(Math.floor((timestamp % (1000 * 60 * 60)) / (1000 * 60)), 0);
  },
  getSeconds: function(timestamp) {
    return Math.max(Math.floor((timestamp % (1000 * 60)) / 1000), 0);
  },
  getCountDownString: function(timestamp) {
    var days = coolCountDownTimer.getDays(timestamp);
    var hours = coolCountDownTimer.getHours(timestamp);
    var minutes = coolCountDownTimer.getMinutes(timestamp);
    var seconds = coolCountDownTimer.getSeconds(timestamp);
    
    if (days < 10) {
        days = '0' + days;
    }
    if (hours < 10) {
        hours = '0' + hours;
    }
    if (minutes < 10) {
        minutes = '0' + minutes;
    }
    if (seconds < 10) {
        seconds = '0' + seconds;
    }
          
    if (days > 0) {
      return days + ":" + hours + ":" + minutes + ":" + seconds;
    }
    else {
      return hours + ":" + minutes + ":" + seconds;
    }
    
    if (timestamp <= 0) {
      return "00:00:00";
    }
  }
}

var coolTimeUntilSoldOutScript = {
  getTimeUntilSoldOut: function (coolAnalyticsJson1hr, coolAnalyticsJsonOneDay, remainingStock) {
    var dateNowUTC = Date.parse(new Date().toISOString());
    var coolAnalyticsJson = null;
    var hoursChecked = 0;

    if (coolAnalyticsJson1hr == null || coolAnalyticsJson1hr == "") {
      coolAnalyticsJson = coolAnalyticsJsonOneDay;
      hoursChecked = 24;
    }
    else if (coolAnalyticsJsonOneDay != null && coolAnalyticsJsonOneDay != "") {
      var onehourAnalytics = JSON.parse(coolAnalyticsJson1hr);
      var oneDayAnalytics = JSON.parse(coolAnalyticsJsonOneDay);
      var oneHourLastChecked = Date.parse(onehourAnalytics.lastCheckedUTC);
      var oneDayLastChecked = Date.parse(oneDayAnalytics.lastCheckedUTC);
      var oneHourExpired = coolTimeUntilSoldOutScript.getHoursExpired(dateNowUTC, 1, oneHourLastChecked) > 0;

      if (oneHourExpired && oneDayLastChecked > oneHourLastChecked) {
        coolAnalyticsJson = coolAnalyticsJsonOneDay;
        hoursChecked = 24;
      }
      else {
        coolAnalyticsJson = coolAnalyticsJson1hr;
        hoursChecked = 1;
      }
    }
    else {
      coolAnalyticsJson = coolAnalyticsJson1hr;
      hoursChecked = 1;
    }

    if (coolAnalyticsJson == null || coolAnalyticsJson == "" || remainingStock <= 0) {
      	return -1;
    }
    else {
      var analytics = JSON.parse(coolAnalyticsJson);
      var lastCheckedUTC = Date.parse(analytics.lastCheckedUTC);
      var expectedSellOutTimeUTC = Date.parse(analytics.expectedSellOutTimeUTC);
      
      var hoursExpired = coolTimeUntilSoldOutScript.getHoursExpired(dateNowUTC, hoursChecked, lastCheckedUTC);
      if (hoursExpired > 0) {
        var newSalesPerHour = (analytics.unitsSoldInPeriod / hoursChecked) / (hoursExpired + hoursChecked);
        var newMinsUntilSoldOut = (remainingStock / newSalesPerHour) * 60;

        var oldMinsUntilSoldOut =  Math.max(Math.floor(((expectedSellOutTimeUTC - lastCheckedUTC) % (1000 * 60 * 60)) / (1000 * 60)), 0);
        var minDiff = Math.abs(newMinsUntilSoldOut - oldMinsUntilSoldOut);
      
        var expectedSellOutTimeUTCObj = new Date(expectedSellOutTimeUTC);
        expectedSellOutTimeUTC = expectedSellOutTimeUTCObj.setMinutes(expectedSellOutTimeUTCObj.getMinutes() + minDiff);
      }
      
      return expectedSellOutTimeUTC - dateNowUTC;
    }
  },
  getHoursExpired: function (dateNowUTC, hoursChecked, lastCheckedUTC){
    const msInHour = 1000 * 65 * 60; /* Allow an extra 5 mins */
    var timeDiff = dateNowUTC - lastCheckedUTC;
    if (timeDiff == null || timeDiff <= 0) {
      return 0;
    }
    
    return Math.floor(Math.abs(dateNowUTC - lastCheckedUTC) / msInHour);
  }
}